import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#09072C",
      gray: "#999999",
      white: "#fff",
    },
    secondary: {
      main: "#3f51b5",
      white: "#D9D9D9",
    },
    error: {
      main: "#f44336",
    },
    warning: {
      main: "#ff9800",
    },
    info: {
      main: "#2196f3",
    },
    success: {
      main: "#4caf50",
    },
    background: {
      blue: "#1D3263",
      purple: "#2C1E4A",
      darkBlue: "#040221",
    },
    button: {
      primary: "#00B7FF",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      mobile_s: 345,
      sm: 600,
      md: 960,
      laptop: 1024,
      lg: 1120,
      xl: 1470,
    },
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    h1: {
      fontSize: "5.25rem", // 84px
      fontWeight: 500,
      lineHeight: "115px",
      color: "#FFFFFF",
    },
    h2: {
      fontSize: "4.25rem", // 68px
      fontWeight: 600,
      lineHeight: "70px",
      color: "#fff",
    },
    h3: {
      fontSize: "2.5rem", // 40px
      fontWeight: 600,
      lineHeight: "90px",
      color: "#fff",
    },
    h4: {
      fontSize: "1.5rem", // 24px
      fontWeight: 500,
      lineHeight: "29.26px",
      color: "#fff",
    },
    h5: {
      fontSize: "0.8rem", // 12.8px
      fontWeight: 500,
      lineHeight: "29.26px",
      color: "#fff",
    },
    subtitle1: {
      fontSize: "1.225rem", // 20px
      fontWeight: 400,
      lineHeight: "22.47px",
      fontFamily: "Inter",
      color: "#fff",
    },
    subtitle2: {
      fontSize: "1.00rem", // 16px
      fontWeight: 400,
      lineHeight: "1.445rem", // 23.12px
      fontFamily: "Inter",
      color: "#000",
    },
  },
});

export default theme;
